export const administrationAccountsSiteLocationAddress = {
    template: require('./administration-accounts-site-location-address.html'),
    controller: 'AdministrationAccountsSiteLocationAddressController'
};
